import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment.prod';
@Injectable({
  providedIn: 'root'
})
export class ReportServiceService {

  constructor(private http: HttpClient) { }

  
  getReportName()
  {
   // alert(environment.user_report_url)
    return this.http.get<any>(environment.user_report_url + "/getReportName", {});
  }

  getExecutedData(executeQuery){
return this.http.post<any>(environment.user_report_url + "/getExecutedData", executeQuery);
  }

  getStaticReportMaster(reportType){
    return this.http.post<any>(environment.user_report_url + "/getStaticReportMaster", reportType);
  }

  getTabularData(tabularId){
    return this.http.post<any>(environment.user_report_url + "/getTabularData", tabularId);
  }

  getMasterData(msData){
    return this.http.post<any>(environment.user_report_url + "/getMasterData", msData);
  }

  getChartsData(tabularId){
    return this.http.post<any>(environment.user_report_url + "/getChartsData", tabularId);
  }

  


}
